import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const ChevronDownIcon: FC<SvgProps> = (props) => {
    return (
        <Svg viewBox="0 0 24 24" height={24} width={24} fill="currentColor" {...props}>
            <Path d="m18.703 9.783-6.649 6.989a.687.687 0 0 1-.257.176.832.832 0 0 1-.297.052.832.832 0 0 1-.297-.052.687.687 0 0 1-.257-.176L4.277 9.783A1.01 1.01 0 0 1 4 9.058c0-.29.099-.54.297-.747A.929.929 0 0 1 4.989 8c.264 0 .495.104.693.311l5.818 6.097 5.818-6.097a.906.906 0 0 1 .682-.29.94.94 0 0 1 .703.31c.198.208.297.45.297.727 0 .276-.099.518-.297.725Z" />
        </Svg>
    )
}

export default ChevronDownIcon
